export default __webpack_public_path__ + "static/media/coursera.db52c733.png";